module.exports = __webpack_public_path__ + "static/media/huoshaoshan_web.c030cdab.webp";